import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ApiUsersService } from '../../../../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../../../../services/alerts.service';
import { DateService } from '../../../../../../../services/date.service';
import { UserMatchDetail } from '../../../../../../../models/users/user-match-detail.model';
import { MatchState } from '../../../../../../../enums/users/match-state.enum';

@Component({
  selector: 'app-user-match-detail-modal',
  templateUrl: './user-match-detail-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, RouterModule, TooltipModule]
})
export class UserMatchDetailModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  protected readonly MatchState = MatchState;

  isLoading: boolean = false;
  matchDetail: UserMatchDetail | null = null;

  constructor(
    public dateService: DateService,
    private apiUsersService: ApiUsersService,
    private alertsService: AlertsService
  ) {}

  show(userId: number, matchId: number): void {
    this.matchDetail = null;
    this.isLoading = true;
    this.modal.show();

    this.apiUsersService.getUserMatch(userId, matchId).then(
      response => {
        this.isLoading = false;
        this.matchDetail = response;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading match details: ' + error);
      }
    );
  }
}
